const id = assoc => assoc?.id || (typeof assoc === 'string' && assoc) || undefined;

export default id;

export const sameId = (assocA, assocB) => {
  const idA = id(assocA);
  const idB = id(assocB);
  return idA === idB && idA !== undefined;
};
